import { createApp, defineComponent } from 'vue';
import GridDurationCellEditor from './GridDurationCellEditor.vue';
import constants from '$$helpers/constants';
import timeParser from '$$helpers/timeParser';
import { getDurationStepForTask } from '../../columns/templates/commonColumns';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridDurationCellEditor);

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder);
      vueInstance = vueApp.mount(placeholder);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;
    },

    set_value(task, id, column, node) {
      const durationData = instance.config.durationData;

      vueInstance.value = timeParser.output(task.duration, {
        durationData,
        durationStep: getDurationStepForTask(task, instance),
        prop: 'duration',
      });;
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      return true;
    },

    is_valid(value, id, column, node) {
      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const durationData = instance.config.durationData;

      const parserResult = timeParser.input(vueInstance.value, {
        durationData,
        durationStep: getDurationStepForTask(task, instance),
        prop: 'duration',
      });

      if (!parserResult) {
        return;
      }

      const value = +parserResult.value || 1;

      if (value > 0 && value <= constants.DURATION_LIMITS.minute && value !== task.duration) {
        task.end_date = instance.calculateEndDate({ start_date: task.start_date, duration: value, task, unit: instance.config.duration_unit });
        task.duration = value;
        instance.updateTask(task.id);

        userExtAnalytics.log('task_grid_action', { action: 'duration' });
      }
    },

    focus(node) {
    },
  };
}
